import './skin.scss';
import * as React from 'react';
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/image';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/link';
import 'tinymce/plugins/paste';
import './locale';
import { Editor as TinyMceEditor } from '@tinymce/tinymce-react';
import { Editor } from 'tinymce/tinymce';
import contentCssFile from './content.css';

export interface IContentEditorState {
  onUpload?: (file: Blob) => Promise<string>;
  initialValue?: string;
}

const getPlugins = (props: IContentEditorState): string[] => {
  const plugins = ['link', 'lists'];

  if (props.onUpload) {
    plugins.push('image');
  }

  return plugins;
};

const getToolbar = (props: IContentEditorState): Array<{ name: string, items: string[] }> => {
  const last = { name: 'extra', items: ['link'] };
  const toolbar = [
    { name: 'formatting', items: ['bold', 'italic', 'underline'] },
    { name: 'alignment', items: ['alignleft', 'aligncenter', 'alignright'] },
    { name: 'list', items: ['numlist', 'bullist'] },
    last
  ];

  if (props.onUpload) {
    last.items.push('image');
  }

  return toolbar;
}

const ContentEditor = React.forwardRef((
  props: IContentEditorState,
  ref: React.MutableRefObject<Editor>
) => {
  const plugins = React.useMemo(() => getPlugins(props), [props]);
  const toolbar = React.useMemo(() => getToolbar(props), [props]);

  return (
    <TinyMceEditor
      init={{
        height: '500',
        base_url: '/static',
        content_css: contentCssFile,
        language: 'da',
        skin: false,
        branding: false,
        statusbar: false,
        menubar: false,
        toolbar,
        plugins,
        images_upload_handler: (file, success) => {
          if (props.onUpload) {
            props.onUpload(file.blob())
              .then(success);
          }
        },
      }}
      onInit={(init, editor) => {
        if (ref) {
          ref.current = editor;
        }
      }}
      initialValue={props.initialValue}
    />
  );
});

export default ContentEditor;



// WEBPACK FOOTER //
// ./src/components/ContentEditor/index.tsx